const host =
  process.env.REACT_APP_API_BASE_URL || 'https://test.api.catp.coimbra.io'

const config = {
  apiBaseUrl: `${host}/api/v1`,
}

export default config
